export default __webpack_public_path__ + "back.a87cff2d2e013760.svg";